var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_3898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2271 1.95744C11.1034 1.74189 10.925 1.56281 10.7099 1.43828C10.4948 1.31375 10.2507 1.24817 10.0021 1.24817C9.75359 1.24817 9.50945 1.31375 9.29437 1.43828C9.07928 1.56281 8.90086 1.74189 8.77713 1.95744L0.205877 16.5412C-0.365373 17.5137 0.319627 18.7499 1.43088 18.7499H18.5721C19.6834 18.7499 20.3696 17.5124 19.7971 16.5412L11.2271 1.95744ZM9.99963 6.24994C10.6684 6.24994 11.1921 6.82744 11.1246 7.49369L10.6871 11.8774C10.6724 12.0497 10.5936 12.2101 10.4663 12.327C10.339 12.4439 10.1725 12.5088 9.99963 12.5088C9.82679 12.5088 9.66024 12.4439 9.53293 12.327C9.40562 12.2101 9.32683 12.0497 9.31213 11.8774L8.87463 7.49369C8.85892 7.33648 8.87631 7.17773 8.92568 7.02765C8.97506 6.87757 9.05532 6.7395 9.16131 6.62233C9.26729 6.50516 9.39664 6.41149 9.54103 6.34735C9.68542 6.28321 9.84164 6.25003 9.99963 6.24994ZM10.0021 13.7499C10.3336 13.7499 10.6516 13.8816 10.886 14.1161C11.1204 14.3505 11.2521 14.6684 11.2521 14.9999C11.2521 15.3315 11.1204 15.6494 10.886 15.8838C10.6516 16.1182 10.3336 16.2499 10.0021 16.2499C9.67061 16.2499 9.35266 16.1182 9.11824 15.8838C8.88382 15.6494 8.75213 15.3315 8.75213 14.9999C8.75213 14.6684 8.88382 14.3505 9.11824 14.1161C9.35266 13.8816 9.67061 13.7499 10.0021 13.7499Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_3898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIcon);
export default __webpack_public_path__ + "static/media/caution-icon.701490d33bc86837772345cf916f933c.svg";
export { ForwardRef as ReactComponent };